import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter
} from "@angular/core";
import { DataService } from "../../../services/data.service";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { SpinnerService } from "shared-components";

@Component({
  selector: "app-avisos-etiquetadores",
  templateUrl: "./avisos-etiquetadores.component.html",
})
export class AvisosEtiquetadoresComponent
  implements OnInit, OnDestroy
{
  public cargaCompleta = false;
  // Este número se deberá devolver desde back mediante un servicio al acceder a la pantalla
  public totalAvisos = 21;

  public expedicionCero = [];
  public datosExpedicionCero = [];

  public expedicionDesignados = [];
  public datosExpedicionDesignados = [];

  public reetiquetados = [];
  public datosReetiquetados = [];

  public etiquetasReimpresas = [];
  public datosEtiquetasReimpresas = [];

  public confecciones = [];
  public datosConfecciones = [];

  public denominaciones = [];
  public datosDenominaciones = [];

  public fallosConexion = [];
  public datosFallosConexion = [];

  public activos = [];
  public datosActivos = [];

  public activosImprimiendo = [];
  public datosActivosImprimiendo = [];

  public almacenes = [];
  public datosAlmacenes = [];

  public allDonuts = [];
  public donutsPorPrioridad = [];
  public donutsAlta;

  public colors = [
    {
      backgroundColor: ["rgba(22,97,76,255)", "rgba(22,97,76,0.4)"],
    },
    {
      backgroundColor: ["rgba(251,128,45,255)", "rgba(251,128,45,0.4)"],
    },
    {
      backgroundColor: ["rgba(193,72,72,255)", "rgba(193,72,72,0.4)"],
    },
  ];

  public toCloseSpinner = 0;

  public gridModal = false;
  public tituloGrid;

  public showAll = true;

  public addFilters = false;

  public dataExpedicionCero;

  public animation;

  @Input() set priority(value: string) {
    if (value === "ALTA") {
      this.showAll = false;
      this.donutsPorPrioridad = this.allDonuts.filter(
        (donut) =>
          donut.colors.backgroundColor[0].toString() ===
          this.colors[2].backgroundColor[0].toString()
      );
    } else if (value === "MEDIA") {
      this.showAll = false;
      this.donutsPorPrioridad = this.allDonuts.filter(
        (donut) =>
          donut.colors.backgroundColor[0].toString() ===
          this.colors[1].backgroundColor[0].toString()
      );
    } else if (value === "BAJA") {
      this.showAll = false;
      this.donutsPorPrioridad = this.allDonuts.filter(
        (donut) =>
          donut.colors.backgroundColor[0].toString() ===
          this.colors[0].backgroundColor[0].toString()
      );
    } else {
      this.showAll = true;
      this.donutsPorPrioridad = [];
    }
  }

  @Input() set startAnimation(value: boolean) {
    this.animation = value;
  }

  @Input() donutsEtiquetadoresInput;
  @Output() donutsEtiquetadoresOutput = new EventEmitter();
  @Output() disableFilters = new EventEmitter();
  @Output() numAvisosTotales = new EventEmitter();
  @Output() numAvisos = new EventEmitter();

  constructor(
    private readonly _dataService: DataService,
    private readonly _sessionContext: SessionContextService,
    private readonly _spinnerService: SpinnerService,
    private readonly _translate: TranslateService
  ) {}

  ngOnInit() {
    if (this.donutsEtiquetadoresInput) {
      this.allDonuts = this.donutsEtiquetadoresInput;
      this.cargaCompleta = true;
    } else {
      const promises: Promise<any>[] = [];

      promises.push(this.getKgExpedicionCero());

      promises.push(this.getKgExpedicionRespectoDesignados({}, "="));
      promises.push(
        this.getKgExpedicionRespectoDesignados({ min: null, max: 50 }, "<")
      );
      promises.push(
        this.getKgExpedicionRespectoDesignados({ min: 50, max: 75 }, "<")
      );
      promises.push(
        this.getKgExpedicionRespectoDesignados({ min: 115, max: 120 }, ">")
      );
      promises.push(
        this.getKgExpedicionRespectoDesignados({ min: 120, max: 125 }, ">")
      );
      promises.push(
        this.getKgExpedicionRespectoDesignados({ min: 125, max: null }, ">")
      );

      promises.push(this.getKgReetiquetados({ min: 10, max: 15 }));
      promises.push(this.getKgReetiquetados({ min: 15, max: 20 }));
      promises.push(this.getKgReetiquetados({ min: 20, max: null }));

      promises.push(this.getEtiquetasReimpresas(1));
      promises.push(this.getEtiquetasReimpresas(2));
      promises.push(this.getEtiquetasReimpresas(3));

      promises.push(this.getConfecciones());

      promises.push(this.getDenominacionesBloqueadas());

      promises.push(this.getFallosConexion());

      promises.push(this.getUsuariosActivos());

      promises.push(this.getUsuariosImprimiendo());

      promises.push(this.getAlmacenes());

      this.disableFilters.emit(true);
      this.numAvisosTotales.emit(this.totalAvisos);
      Promise.all(promises)
        .then(
          () => {
            this.agruparInfo();
            this.disableFilters.emit(false);
            this.cargaCompleta = true;
          },
          (error) => {
            console.log("Promise rejected with " + JSON.stringify(error));
          }
        )
        .catch((e) => console.log(e));
    }

    // Descomentar si hay problemas en el redibujado
    // window.onfocus = (e) => {
    //     this.dibujarDonuts();
    // };
  }

  ngOnDestroy() {
    this.donutsEtiquetadoresOutput.emit(this.allDonuts);
  }

  // private dibujarDonuts() {
  //     this.datosExpedicionCero.forEach(expCero => {
  //         this.expedicionCero[expCero.prioridad] = {
  //             label: 'Kg. Expedición = 0',
  //             subLabel: '(' + expCero.dias + ' ' + 'días)',
  //             descripcion: 'Etiquetadores que no han consumido kilos de expedición a los'
  //                 + ' ' + expCero.dias + ' ' + 'días de iniciarse la campaña.',
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [expCero.porcentaje, (100 - expCero.porcentaje).toFixed(2), expCero.numerador + '/' + expCero.denominador],
  //             colors: expCero.color
  //         };
  //     });

  //     this.datosExpedicionDesignados.forEach((expedicion, index) => {
  //         this.expedicionDesignados[index] = {
  //             label: expedicion.label,
  //             subLabel: expedicion.subLabel,
  //             descripcion: expedicion.descripcion,
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [expedicion.porcentaje,
  //             (100 - expedicion.porcentaje).toFixed(2), expedicion.numerador + '/' + expedicion.denominador],
  //             colors: expedicion.color
  //         };
  //     });

  //     this.datosReetiquetados.forEach((reetiquetado, index) => {
  //         this.reetiquetados[index] = {
  //             label: 'Kg. Reetiquetados',
  //             subLabel: reetiquetado.subLabel,
  //             descripcion: reetiquetado.descripcion,
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [reetiquetado.porcentaje,
  //             (100 - reetiquetado.porcentaje).toFixed(2), reetiquetado.numerador + '/' + reetiquetado.denominador],
  //             colors: reetiquetado.color
  //         };
  //     });

  //     this.datosEtiquetasReimpresas.forEach((etiqueta, index) => {
  //         this.etiquetasReimpresas[index] = {
  //             label: 'Etiquetas Reimpresas',
  //             subLabel: etiqueta.subLabel,
  //             descripcion: etiqueta.descripcion,
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [etiqueta.porcentaje,
  //             (100 - etiqueta.porcentaje).toFixed(2), etiqueta.numerador + '/' + etiqueta.denominador],
  //             colors: etiqueta.color
  //         };
  //     });

  //     this.datosConfecciones.forEach((confeccion, index) => {
  //         this.confecciones[index] = {
  //             label: 'Nº Confecciones = 0',
  //             subLabel: '',
  //             descripcion: 'Etiquetadores que todavía no han creado ninguna confección.',
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [confeccion.porcentaje, (100 - confeccion.porcentaje).toFixed(2), confeccion.numerador + '/' + confeccion.denominador],
  //             colors: confeccion.color
  //         };
  //     });

  //     this.datosDenominaciones.forEach((denominacion, index) => {
  //         this.denominaciones[index] = {
  //             label: 'Denominaciones Bloqueadas',
  //             subLabel: '',
  //             descripcion: 'Etiquetadores que tienen denominaciones bloqueadas.',
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [denominacion.porcentaje, (100 - denominacion.porcentaje).toFixed(2), denominacion.numerador + '/' + denominacion.denominador],
  //             colors: denominacion.color
  //         };
  //     });

  //     this.datosFallosConexion.forEach((fallo, index) => {
  //         this.fallosConexion[index] = {
  //             label: 'Fallos de conexión al servidor',
  //             subLabel: '',
  //             descripcion: 'Etiquetadores que han tenido problemas con la conexión al servidor de Gesvatec.',
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [fallo.porcentaje, (100 - fallo.porcentaje).toFixed(2), fallo.numerador + '/' + fallo.denominador],
  //             colors: fallo.color
  //         };
  //     });

  //     this.datosActivos.forEach((activo, index) => {
  //         this.activos[index] = {
  //             label: 'Login Web',
  //             subLabel: '',
  //             descripcion: 'Usuarios de los Etiquetadores que están ahora utilizando la web.',
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [activo.porcentaje, (100 - activo.porcentaje).toFixed(2), activo.numerador + '/' + activo.denominador],
  //             colors: activo.color
  //         };
  //     });

  //     this.datosActivosImprimiendo.forEach((activo, index) => {
  //         this.activosImprimiendo[index] = {
  //             label: 'Imprimiendo Etiquetas',
  //             subLabel: '',
  //             descripcion: 'Etiquetadores que están imprimiendo etiquetas en estos momentos.',
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [activo.porcentaje, (100 - activo.porcentaje).toFixed(2), activo.numerador + '/' + activo.denominador],
  //             colors: activo.color
  //         };
  //     });

  //     this.datosAlmacenes.forEach((almacen, index) => {
  //         this.almacenes[index] = {
  //             label: 'Nº Almacenes > 1',
  //             subLabel: '',
  //             descripcion: 'Etiquetadores que tienen más de un almacén.',
  //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
  //             dataList: [almacen.porcentaje, (100 - almacen.porcentaje).toFixed(2), almacen.numerador + '/' + almacen.denominador],
  //             colors: almacen.color
  //         };
  //     });
  // }

  public getKgExpedicionCero(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getKilosExpedicionCero()
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(3);
        })
        .then(
          (resp) => {
            if (resp) {
              this.datosExpedicionCero[0] = {
                dias: 30,
                porcentaje: resp.graficaCeroKg_30Dias.porcentaje,
                numerador: resp.graficaCeroKg_30Dias.numerador,
                denominador: resp.graficaCeroKg_30Dias.denominador,
                color: this.colors[0],
                prioridad:
                  resp.graficaCeroKg_30Dias.centralAvisosPrioridadId - 1,
              };

              this.datosExpedicionCero[1] = {
                dias: 45,
                porcentaje: resp.graficaCeroKg_45Dias.porcentaje,
                numerador: resp.graficaCeroKg_45Dias.numerador,
                denominador: resp.graficaCeroKg_45Dias.denominador,
                color: this.colors[1],
                prioridad:
                  resp.graficaCeroKg_45Dias.centralAvisosPrioridadId - 1,
              };

              this.datosExpedicionCero[2] = {
                dias: 60,
                porcentaje: resp.graficaCeroKg_60Dias.porcentaje,
                numerador: resp.graficaCeroKg_60Dias.numerador,
                denominador: resp.graficaCeroKg_60Dias.denominador,
                color: this.colors[2],
                prioridad:
                  resp.graficaCeroKg_60Dias.centralAvisosPrioridadId - 1,
              };

              this.expedicionCero[0] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.label"
                ),
                subLabel: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.subLabel30"
                ),
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.descripcion30"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.graficaCeroKg_30Dias.porcentaje,
                  (100 - resp.graficaCeroKg_30Dias.porcentaje).toFixed(2),
                  resp.graficaCeroKg_30Dias.numerador +
                    "/" +
                    resp.graficaCeroKg_30Dias.denominador,
                ],
                colors: this.colors[0],
              };

              this.expedicionCero[1] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.label"
                ),
                subLabel: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.subLabel45"
                ),
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.descripcion45"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.graficaCeroKg_45Dias.porcentaje,
                  (100 - resp.graficaCeroKg_45Dias.porcentaje).toFixed(2),
                  resp.graficaCeroKg_45Dias.numerador +
                    "/" +
                    resp.graficaCeroKg_45Dias.denominador,
                ],
                colors: this.colors[1],
              };

              this.expedicionCero[2] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.label"
                ),
                subLabel: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.subLabel60"
                ),
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.expedicionCero.descripcion60"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.graficaCeroKg_60Dias.porcentaje,
                  (100 - resp.graficaCeroKg_60Dias.porcentaje).toFixed(2),
                  resp.graficaCeroKg_60Dias.numerador +
                    "/" +
                    resp.graficaCeroKg_60Dias.denominador,
                ],
                colors: this.colors[2],
              };
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getKgExpedicionRespectoDesignados(
    porcentajes,
    operador
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let filters;
      if (operador === "=") {
        filters = {
          operadorIgualdad: true,
        };
      } else {
        filters = {
          porcentajeMin: porcentajes.min ? porcentajes.min : null,
          porcentajeMax: porcentajes.max ? porcentajes.max : null,
        };
      }

      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getKilosExpedicionRespectoDesignados(filters)
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              if (operador === "=") {
                this.datosExpedicionDesignados[0] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcionIgual"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.expedicionDesignados[0] = {
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcionIgual"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (operador === "<" && !porcentajes.min) {
                this.datosExpedicionDesignados[1] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcionMenos50"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(<50%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.expedicionDesignados[1] = {
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(<50%)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcionMenos50"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (operador === "<" && porcentajes.max) {
                this.datosExpedicionDesignados[2] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcion5075"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(50%-75%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.expedicionDesignados[2] = {
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(50%-75%)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcion5075"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (operador === ">" && porcentajes.max === 120) {
                this.datosExpedicionDesignados[3] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcion1520"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(15%-20%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.expedicionDesignados[3] = {
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(15%-20%)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcion1520"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (operador === ">" && porcentajes.max === 125) {
                this.datosExpedicionDesignados[4] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcion2025"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(20%-25%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.expedicionDesignados[4] = {
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(20%-25%)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcion2025"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (operador === ">" && !porcentajes.max) {
                this.datosExpedicionDesignados[5] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcionMas25"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(>25%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.expedicionDesignados[5] = {
                  label:
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.etiquetadores.expedicionDesignados.postLabel"
                    ),
                  subLabel: "(>25%)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.expedicionDesignados.descripcionMas25"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              }
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getKgReetiquetados(porcentajes): Promise<any> {
    return new Promise((resolve, reject) => {
      let filters;
      if (porcentajes.max) {
        filters = {
          porcentajeMin: porcentajes.min,
          porcentajeMax: porcentajes.max,
        };
      } else if (!porcentajes.max) {
        filters = {
          porcentajeMin: porcentajes.min,
        };
      }
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getKilosReetiquetados(filters)
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              if (porcentajes.min === 10) {
                this.datosReetiquetados[0] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.descripcion1015"
                  ),
                  subLabel: "(10%-15%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.reetiquetados[0] = {
                  label: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.label"
                  ),
                  subLabel: "(10%-15%)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.descripcion1015"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (porcentajes.min === 15) {
                this.datosReetiquetados[1] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.descripcion1520"
                  ),
                  subLabel: "(15%-20%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.reetiquetados[1] = {
                  label: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.label"
                  ),
                  subLabel: "(15%-20%)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.descripcion1520"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (!porcentajes.max) {
                this.datosReetiquetados[2] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.descripcionMas20"
                  ),
                  subLabel: "(>20%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.reetiquetados[2] = {
                  label: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.label"
                  ),
                  subLabel: "(>20%)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.reetiquetado.descripcionMas20"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              }
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getEtiquetasReimpresas(tipo): Promise<any> {
    return new Promise((resolve, reject) => {
      let filters;
      if (tipo === 1) {
        filters = {
          numeroMin: 1000,
          numeroMax: 3000,
        };
      } else if (tipo === 2) {
        filters = {
          numeroMin: 3000,
          numeroMax: 5000,
        };
      } else if (tipo === 3) {
        filters = {
          numeroMin: 5000,
        };
      }
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getEtiquetasReimpresas(filters)
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              if (tipo === 1) {
                this.datosEtiquetasReimpresas[0] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.descripcion13"
                  ),
                  subLabel: "(1.000-3.000)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.etiquetasReimpresas[0] = {
                  label: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.label"
                  ),
                  subLabel: "(1.000-3.000)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.descripcion13"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (tipo === 2) {
                this.datosEtiquetasReimpresas[1] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.descripcion35"
                  ),
                  subLabel: "(3.000-5.000)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.etiquetasReimpresas[1] = {
                  label: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.label"
                  ),
                  subLabel: "(3.000-5.000)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.descripcion35"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (tipo === 3) {
                this.datosEtiquetasReimpresas[2] = {
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.descripcionMas5"
                  ),
                  subLabel: "(>5.000)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.etiquetasReimpresas[2] = {
                  label: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.label"
                  ),
                  subLabel: "(>5.000)",
                  descripcion: this._translate.instant(
                    "central-avisos.etiquetadores.etiquetasReimpresas.descripcionMas5"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              }
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getConfecciones(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getConfecciones()
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              this.datosConfecciones[0] = {
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.confecciones.descripcion"
                ),
                porcentaje: resp.porcentaje,
                numerador: resp.numerador,
                denominador: resp.denominador,
                color: this.colors[resp.centralAvisosPrioridadId - 1],
                prioridad: resp.centralAvisosPrioridadId - 1,
              };

              this.confecciones[0] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.confecciones.label"
                ),
                subLabel: "",
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.confecciones.descripcion"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.porcentaje,
                  (100 - resp.porcentaje).toFixed(2),
                  resp.numerador + "/" + resp.denominador,
                ],
                colors: this.colors[resp.centralAvisosPrioridadId - 1],
              };
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getDenominacionesBloqueadas(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getDenominacionesBloqueadas()
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              this.datosDenominaciones[0] = {
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.denominacionesBloqueadas.descripcion"
                ),
                porcentaje: resp.porcentaje,
                numerador: resp.numerador,
                denominador: resp.denominador,
                color: this.colors[resp.centralAvisosPrioridadId - 1],
                prioridad: resp.centralAvisosPrioridadId - 1,
              };

              this.denominaciones[0] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.denominacionesBloqueadas.label"
                ),
                subLabel: "",
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.denominacionesBloqueadas.descripcion"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.porcentaje,
                  (100 - resp.porcentaje).toFixed(2),
                  resp.numerador + "/" + resp.denominador,
                ],
                colors: this.colors[resp.centralAvisosPrioridadId - 1],
              };
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getFallosConexion(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getFallosConexionServidor()
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              this.datosFallosConexion[0] = {
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.fallosConexion.descripcion"
                ),
                porcentaje: resp.porcentaje,
                numerador: resp.numerador,
                denominador: resp.denominador,
                color: this.colors[resp.centralAvisosPrioridadId - 1],
                prioridad: resp.centralAvisosPrioridadId - 1,
              };

              this.fallosConexion[0] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.fallosConexion.label"
                ),
                subLabel: "",
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.fallosConexion.descripcion"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.porcentaje,
                  (100 - resp.porcentaje).toFixed(2),
                  resp.numerador + "/" + resp.denominador,
                ],
                colors: this.colors[resp.centralAvisosPrioridadId - 1],
              };
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getUsuariosActivos(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getUsuariosActivosWeb()
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              this.datosActivos[0] = {
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.usuariosActivos.descripcion"
                ),
                porcentaje: resp.porcentaje,
                numerador: resp.numerador,
                denominador: resp.denominador,
                color: this.colors[resp.centralAvisosPrioridadId - 1],
                prioridad: resp.centralAvisosPrioridadId - 1,
              };

              this.activos[0] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.usuariosActivos.label"
                ),
                subLabel: "",
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.usuariosActivos.descripcion"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.porcentaje,
                  (100 - resp.porcentaje).toFixed(2),
                  resp.numerador + "/" + resp.denominador,
                ],
                colors: this.colors[resp.centralAvisosPrioridadId - 1],
              };
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getUsuariosImprimiendo(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getEtiquetadoresImprimiendo()
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              this.datosActivosImprimiendo[0] = {
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.activosImprimiendo.descripcion"
                ),
                porcentaje: resp.porcentaje,
                numerador: resp.numerador,
                denominador: resp.denominador,
                color: this.colors[resp.centralAvisosPrioridadId - 1],
                prioridad: resp.centralAvisosPrioridadId - 1,
              };

              this.activosImprimiendo[0] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.activosImprimiendo.label"
                ),
                subLabel: "",
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.activosImprimiendo.descripcion"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.porcentaje,
                  (100 - resp.porcentaje).toFixed(2),
                  resp.numerador + "/" + resp.denominador,
                ],
                colors: this.colors[resp.centralAvisosPrioridadId - 1],
              };
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getAlmacenes(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getAlmacenes({ numeroMin: 2, numeroMax: null })
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              this.datosAlmacenes[0] = {
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.almacenes.descripcion"
                ),
                porcentaje: resp.porcentaje,
                numerador: resp.numerador,
                denominador: resp.denominador,
                color: this.colors[resp.centralAvisosPrioridadId - 1],
                prioridad: resp.centralAvisosPrioridadId - 1,
              };

              this.almacenes[0] = {
                label: this._translate.instant(
                  "central-avisos.etiquetadores.almacenes.label"
                ),
                subLabel: "",
                descripcion: this._translate.instant(
                  "central-avisos.etiquetadores.almacenes.descripcion"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.porcentaje,
                  (100 - resp.porcentaje).toFixed(2),
                  resp.numerador + "/" + resp.denominador,
                ],
                colors: this.colors[resp.centralAvisosPrioridadId - 1],
              };
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  private agruparInfo() {
    for (let expecicionCero of this.expedicionCero) {
      this.allDonuts.push(expecicionCero);
    }

    for (let expedicion of this.expedicionDesignados) {
      this.allDonuts.push(expedicion);
    }

    for (let reetiquetado of this.reetiquetados) {
      this.allDonuts.push(reetiquetado);
    }

    for (let etiqueta of this.etiquetasReimpresas) {
      this.allDonuts.push(etiqueta);
    }

    for (let confeccion of this.confecciones) {
      this.allDonuts.push(confeccion);
    }

    for (let denominacion of this.denominaciones) {
      this.allDonuts.push(denominacion);
    }

    for (let falloConexion of this.fallosConexion) {
      this.allDonuts.push(falloConexion);
    }

    for (let usuario of this.activos) {
      this.allDonuts.push(usuario);
    }

    for (let activo of this.activosImprimiendo) {
      this.allDonuts.push(activo);
    }

    for (let almacen of this.almacenes) {
      this.allDonuts.push(almacen);
    }
  }

  private checkCloseSpinner() {
    if (this.toCloseSpinner === 1) {
      this.toCloseSpinner -= 1;
    }
    if (this.toCloseSpinner === 0) {
      this._spinnerService.hideSpinner();
    }
  }

  public showGrid(donut) {
    this.tituloGrid = donut.label + " " + donut.subLabel;
    this.gridModal = true;
  }

  public refresh(value) {
    this.gridModal = false;
  }

  public getDataExpedicionCero(data) {
    if (data) {
      this.dataExpedicionCero = data;
    }
  }
}
